"use client";

import { useTranslations } from "next-intl";

import { NAV_PREVIEW_SUBNAV_GRADIENT } from "./nav-preview-blue-gradient";
import { NavPreviewSubnav } from "./nav-preview-subnav";
import { NavPreviewFrame } from "./preview-frame";

export function CompanyPartnersNavPreview() {
  const t = useTranslations("Nav.preview.partners");

  const links = [
    { label: t("links.becomePartner"), href: "/partners" },
    { label: t("links.brokers"), href: "/broker" },
    { label: t("links.platforms"), href: "/hosted-capital" },
    {
      label: t("links.agencies"),
      href: "https://platformpartners.wayflyer.com/",
      external: true,
    },
  ] as const;

  return (
    <NavPreviewFrame
      className={NAV_PREVIEW_SUBNAV_GRADIENT}
      contentClassName="items-start justify-start p-0 pl-[54px] pt-[46px]"
    >
      <NavPreviewSubnav columns={1} label={t("label")} links={links} />
    </NavPreviewFrame>
  );
}
